const firebaseConfig = {
  apiKey: document.querySelector('meta[name="firebase-api-key"]').content,
  appId: document.querySelector('meta[name="firebase-app-id"]').content,
  authDomain: document.querySelector('meta[name="firebase-auth-domain"]').content,
  measurementId: document.querySelector('meta[name="firebase-measurement-id"]').content,
  messagingSenderId: document.querySelector('meta[name="firebase-messaging-sender-id"]').content,
  projectId: document.querySelector('meta[name="firebase-project-id"]').content,
  storageBucket: document.querySelector('meta[name="firebase-storage-bucket"]').content,
  vapidKey: document.querySelector('meta[name="firebase-vapid-key"]').content,
};

export { firebaseConfig };
